import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from 'antd';
import { UpOutlined } from '@ant-design/icons';
import TooltipHelp from 'components/Tooltip/tooltipHelp';
import ButtonComponent from 'components/Button';
import ButtonsFinalizar from 'components/Button/ButtonDropdownFinalizar';
import { disableActionPerfil, verificarAvisoFormulario } from 'components/Modal/ModalJustificativa/Modal';
import {
  getMensagemTooltip,
  verificarButtonAnalise,
} from 'components/Modal/ModalJustificativa/ModalButtonsUsuarioFrente';
import { fetchAdicionarJustificativa, fetchAlterarStatusFormulario } from 'store/fetchActions/fetchFormulario';
import { fetchSalvarArquivos } from 'store/fetchActions/fetchArquivo';
import {
  fetchStatusModalEncaminhar,
  fetchStatusModalJustificativa,
  fetchUpdateDadosMinimizados,
} from 'store/fetchActions/fetchApp';
import { exibirModalResumoFinalizar } from './Modal';
import {
  ENUM_MODAL,
  ENUM_CARGO,
  MSG_CAMPO_OBRIGATORIO,
  STATUS_REQUERIMENTO,
  MSG_TOOLTIP_SALVAR_TEXTO,
  MSG_TOOLTIP_SALVAR_DEVOLVER,
  MSG_TOOLTIP_FINALIZAR,
  MSG_TOOLTIP_ENCAMINHAR,
  MSG_TOOLTIP_ADICIONAR_ANALISE,
  MSG_TOOLTIP_ADICIONAR_ATENDIMENTO,
  MSG_TOOLTIP_CANCELAR,
} from 'utils/consts';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { formatterFileFrontToBack } from 'utils/formatter/arquivos';
import { formatterJustificativaFrontToBack } from 'utils/formatter/justificativa';

export const ButtonModalUsuarioFrente = ({
  setExibirLoading,
  sucessoFinalizar,
  valueJustificativa,
  arquivos,
  setError,
  resetModal,
  getDadosJustificativa,
}) => {
  const dispatch = useDispatch();

  const dadosDetalhar = useSelector(state => state.formulario.dadosExibirDetalhar);
  const atendenteLogado = useSelector(state => state.atendente.atendenteLogado);
  const user = useSelector(state => state.sefaz.userProfile);
  const modalState = useSelector(state => state.app.modal);

  const [showDropdownFinalizar, setShowDropdownFinalizar] = useState(false);

  const { showButtonAddAnalise, showButtonRemoveAnalise } = verificarButtonAnalise(
    dadosDetalhar?.status?.identificador
  );

  const handleEncaminharRequerimento = () => {
    const modal =
      atendenteLogado?.cargoId === ENUM_CARGO.ATENDENTE
        ? ENUM_MODAL.ENCAMINHAR.ATENDENTE
        : ENUM_MODAL.ENCAMINHAR.SUPERVISOR;

    dispatch(
      fetchStatusModalEncaminhar(true, modal, {
        justificativa: valueJustificativa,
      })
    );
    dispatch(fetchStatusModalJustificativa(false, ''));
    dispatch(fetchUpdateDadosMinimizados(getDadosJustificativa()));
    resetModal();
  };

  const validarCampo = justificativa => {
    if (!justificativa) {
      setError('justificativa', { type: 'Custom', message: MSG_CAMPO_OBRIGATORIO });
      return false;
    }
    return true;
  };

  const handleAlterarStatus = novoStatus => {
    return new Promise((resolve, reject) => {
      dispatch(fetchAlterarStatusFormulario(dadosDetalhar?.id, novoStatus?.id))
        .then(() => resolve())
        .catch(() => {
          setExibirLoading(false);
          reject();
        });
    });
  };

  async function salvarJustificativa(isFinalizar, novoStatusId) {
    const arquivosFormatados = await formatterFileFrontToBack(
      arquivos,
      {
        id: dadosDetalhar?.id,
        localizador: dadosDetalhar?.localizador,
      },
      atendenteLogado?.id
    );

    const objetoJustificativa = formatterJustificativaFrontToBack(
      valueJustificativa,
      dadosDetalhar?.id,
      atendenteLogado?.id,
      true,
      novoStatusId
    );

    return new Promise((resolve, reject) => {
      if (!validarCampo(valueJustificativa)) {
        setExibirLoading(false);
        reject();
        return;
      }

      setExibirLoading(true);
      dispatch(fetchAdicionarJustificativa(objetoJustificativa))
        .then(() => {
          dispatch(fetchSalvarArquivos(arquivosFormatados))
            .then(() => resolve(true))
            .catch(() => reject(false))
            .finally(() => {
              if (isFinalizar) sucessoFinalizar(isFinalizar);
            });
        })
        .catch(() => {
          setExibirLoading(false);
          reject();
        });
    });
  }

  function salvarJustificativaAlterarStatus(novoStatus) {
    if (!validarCampo(valueJustificativa)) return;
    setExibirLoading(true);
    salvarJustificativa(false, novoStatus?.id).then(() => {
      handleAlterarStatus(novoStatus)
        .then(() => sucessoFinalizar(novoStatus?.identificador))
        .catch(() => setExibirLoading(false));
    });
  }

  const handleExibirModalResumoFinalizar = status => {
    if (!validarCampo(valueJustificativa)) return;
    dispatch(
      exibirModalResumoFinalizar(
        status,
        salvarJustificativaAlterarStatus,
        modalState?.title,
        valueJustificativa,
        arquivos
      )
    );
    dispatch(fetchStatusModalJustificativa(false, ''));
    dispatch(fetchUpdateDadosMinimizados(getDadosJustificativa()));
  };

  const verificarAlteracaoStatus = (functionExecute, status) => {
    setShowDropdownFinalizar(false);
    if (!validarCampo(valueJustificativa)) return;
    verificarAvisoFormulario(
      dadosDetalhar?.status?.identificador,
      dadosDetalhar?.isEqualsAtendente,
      functionExecute,
      status
    );
  };

  return (
    <>
      <ButtonComponent
        text={'Salvar Texto'}
        clickAction={() => salvarJustificativa(true, dadosDetalhar?.status?.id)}
        css={{ margin: '5px' }}
        disabled={disableActionPerfil(atendenteLogado?.cargoId, dadosDetalhar?.status?.identificador)}
        messageTooltip={MSG_TOOLTIP_SALVAR_TEXTO}
      />
      <ButtonComponent
        text={'Salvar e Devolver'}
        clickAction={() =>
          verificarAlteracaoStatus(salvarJustificativaAlterarStatus, STATUS_REQUERIMENTO.DEVOLVIDO_CONTRIBUINTE)
        }
        css={{ margin: '5px' }}
        disabled={disableActionPerfil(atendenteLogado?.cargoId, dadosDetalhar?.status?.identificador)}
        messageTooltip={MSG_TOOLTIP_SALVAR_DEVOLVER}
      />
      <ButtonComponent
        text={'Encaminhar atendimento'}
        clickAction={() => verificarAlteracaoStatus(handleEncaminharRequerimento, null)}
        css={{ margin: '5px' }}
        disabled={disableActionPerfil(atendenteLogado?.cargoId, dadosDetalhar?.status?.identificador)}
        messageTooltip={MSG_TOOLTIP_ENCAMINHAR}
      />
      <Dropdown
        overlay={
          <ButtonsFinalizar
            funcHandleFinalizar={handleExibirModalResumoFinalizar}
            funcHandleIsValid={verificarAlteracaoStatus}
          />
        }
        onVisibleChange={() => {
          setShowDropdownFinalizar(!showDropdownFinalizar);
        }}
        placement="topCenter"
        visible={showDropdownFinalizar}
        disabled={
          disableActionPerfil(atendenteLogado?.cargoId, dadosDetalhar?.status?.identificador) ||
          dadosDetalhar?.status?.identificador === STATUS_REQUERIMENTO.ABERTO.identificador
        }
      >
        <ButtonComponent
          text={'Finalizar atendimento'}
          css={{ margin: '5px' }}
          icon={<UpOutlined />}
          messageTooltip={MSG_TOOLTIP_FINALIZAR}
        />
      </Dropdown>
      {showButtonAddAnalise && (
        <ButtonComponent
          text={'Alterar para Em Análise'}
          clickAction={() => verificarAlteracaoStatus(salvarJustificativaAlterarStatus, STATUS_REQUERIMENTO.EM_ANALISE)}
          css={{ margin: '5px' }}
          disabled={
            dadosDetalhar?.status?.identificador === STATUS_REQUERIMENTO.ABERTO.identificador ||
            dadosDetalhar?.status?.identificador === STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE.identificador
          }
          messageTooltip={MSG_TOOLTIP_ADICIONAR_ANALISE}
        />
      )}
      {showButtonRemoveAnalise && (
        <ButtonComponent
          text={'Alterar para Em Atendimento'}
          clickAction={() =>
            verificarAlteracaoStatus(salvarJustificativaAlterarStatus, STATUS_REQUERIMENTO.EM_ATENDIMENTO)
          }
          css={{ margin: '5px' }}
          disabled={
            dadosDetalhar?.status?.identificador === STATUS_REQUERIMENTO.ABERTO.identificador ||
            dadosDetalhar?.status?.identificador === STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE.identificador
          }
          messageTooltip={MSG_TOOLTIP_ADICIONAR_ATENDIMENTO}
        />
      )}
      {user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR && (
        <ButtonComponent
          text="Cancelar Requerimento"
          clickAction={() => verificarAlteracaoStatus(salvarJustificativaAlterarStatus, STATUS_REQUERIMENTO.CANCELADO)}
          css={{ margin: '5px', cor: '#d40d27' }}
          disabled={
            dadosDetalhar?.status?.identificador === STATUS_REQUERIMENTO.FINALIZADO_DEFERIDO.identificador ||
            dadosDetalhar?.status?.identificador === STATUS_REQUERIMENTO.FINALIZADO_PROCESSO_GERADO.identificador ||
            dadosDetalhar?.status?.identificador === STATUS_REQUERIMENTO.FINALIZADO_INDEFERIDO.identificador ||
            dadosDetalhar?.status?.identificador === STATUS_REQUERIMENTO.CANCELADO.identificador
          }
          messageTooltip={MSG_TOOLTIP_CANCELAR}
        />
      )}
      <TooltipHelp
        text={getMensagemTooltip(showButtonAddAnalise, showButtonRemoveAnalise, user?.profile)}
        forceScroll={{ height: '300px', width: '400px' }}
        style={{ marginTop: '12px' }}
      />
    </>
  );
};

export default ButtonModalUsuarioFrente;
